import { tileLayer } from 'leaflet';
import { isEqual } from 'lodash';
import { PropTypes } from 'react';
import L from 'leaflet';
import corslite from 'corslite';

import childrenType from 'react-leaflet/lib/propTypes/children';
import GridLayer from 'react-leaflet/lib/GridLayer';
import TileLayer from 'react-leaflet/lib/TileLayer';

L.UTFGrid = L.TileLayer.extend({
  options: {
    resolution: 4,
    pointerCursor: true,
    mouseInterval: 66,  // Delay for mousemove events
  },

  _mouseOn: null,
  _mouseOnTile: null,
  _tileCharCode: null, // '<tileKey>:<charCode>' or null
  _cache: null, // {<tileKey>: <utfgrid>}
  _idIndex: null, // {<featureID>: {<tileKey1>: true, ...<tileKeyN>: true} }
  _throttleMove: null, // holds throttled mousemove handler
  //_throttleConnectEventHandlers: null, // holds throttled connection setup function

  _updateCursor: function(){ }, //no-op, overridden below

  onAdd: function (map) {
        this._cache = {};
        this._idIndex = {};

        L.TileLayer.prototype.onAdd.call(this, map);

        this._throttleMove = L.Util.throttle(this._move, this.options.mouseInterval, this);

        if (this.options.pointerCursor) {
            this._updateCursor = function(cursor) { this._container.style.cursor = cursor; }
        }

        map.on('boxzoomstart', this._disconnectMapEventHandlers, this);
        // have to throttle or we get an immediate click event on boxzoomend
        map.on('boxzoomend', this._throttleConnectEventHandlers, this);
        this._connectMapEventHandlers();
  },

  onRemove: function () {
    var map = this._map;
        map.off('boxzoomstart', this._disconnectMapEventHandlers, this);
        map.off('boxzoomend', this._throttleConnectEventHandlers, this);
        this._disconnectMapEventHandlers();
    this._updateCursor('');
        L.TileLayer.prototype.onRemove.call(this, map);
  },

    createTile: function(coords) {
        this._loadTile(coords);
        return document.createElement('div');  // empty DOM node, required because this overrides L.TileLayer
  },

    _connectMapEventHandlers: function(){
        this._map.on('click', this._onClick, this);
        this._map.on('mousemove', this._throttleMove, this);
    },

    _disconnectMapEventHandlers: function(){
        this._map.off('click', this._onClick, this);
        this._map.off('mousemove', this._throttleMove, this);
    },

    _throttleConnectEventHandlers: function() {
        setTimeout(this._connectMapEventHandlers.bind(this), 100);
    },

    _update: function (center, zoom) {
        L.TileLayer.prototype._update.call(this, center, zoom);
    },

    _loadTile: function (coords) {
        var { maxCol, minCol, maxRow, minRow} = this.options.limits[coords.z][coords.z];
        var isInRange = false;
        if (coords.y <= maxRow && coords.y >= minRow && coords.x >= minCol && coords.x <= maxCol) {
            isInRange=true
        } else {
            return;
        };
        var url = this.getTileUrl(coords);
        var key = this._tileCoordsToKey(coords);
        var self = this;
        if (this._cache[key]) { return }
        corslite(url, function(err, response){
            if (err) {
                self.fire('error', {error: err});
                return;
            }
            var data = JSON.parse(response.responseText);
            self._cache[key] = data;
            L.Util.bind(self._handleTileLoad, self)(key, data);
        }, true);
  },

    _handleTileLoad: function(key, data) {
        // extension point
    },

  _onClick: function (e) {
    this.fire('click', this._objectForEvent(e));
  },

  _move: function (e) {
        if (e.latlng == null){ return }

    var on = this._objectForEvent(e);

        if (on._tileCharCode !== this._tileCharCode) {
      if (this._mouseOn) {
        this.fire('mouseout', {
            latlng: e.latlng,
            data: this._mouseOn,
            _tile: this._mouseOnTile,
            _tileCharCode: this._tileCharCode
        });
        this._updateCursor('');
      }
      if (on.data) {
        this.fire('mouseover', on);
        this._updateCursor('pointer');
      }

      this._mouseOn = on.data;
            this._mouseOnTile = on._tile;
            this._tileCharCode = on._tileCharCode;
    } else if (on.data) {
      this.fire('mousemove', on);
    }
  },

  _objectForEvent: function (e) {
      if (!e.latlng) return;  // keyboard <ENTER> events also pass through as click events but don't have latlng

        var map = this._map,
        point = map.project(e.latlng),
        tileSize = this.options.tileSize,
        resolution = this.options.resolution,
        x = Math.floor(point.x / tileSize),
        y = Math.floor(point.y / tileSize),
        gridX = Math.floor((point.x - (x * tileSize)) / resolution),
        gridY = Math.floor((point.y - (y * tileSize)) / resolution),
      max = map.options.crs.scale(map.getZoom()) / tileSize;

        x = (x + max) % max;
        y = (y + max) % max;
        

        var tileKey = this._tileCoordsToKey({z: map.getZoom(), x: x, y: y});

    var data = this._cache[tileKey];
    if (!data) {
      return {
                latlng: e.latlng,
                data: null,
                _tile: null,
                _tileCharCode: null
            };
    }

        var charCode = data.grid[gridY].charCodeAt(gridX);
    var idx = this._utfDecode(charCode),
        key = data.keys[idx],
        result = data.data[key];

    if (!data.data.hasOwnProperty(key)) {
      result = null;
    }

    return {
            latlng: e.latlng,
            data: result,
            id: (result)? result.id: null,
            _tile: tileKey,
            _tileCharCode: tileKey + ':' + charCode
        };
  },

    _dataForCharCode: function (tileKey, charCode) {
        var data = this._cache[tileKey];
        var idx = this._utfDecode(charCode),
        key = data.keys[idx],
        result = data.data[key];

    if (!data.data.hasOwnProperty(key)) {
      result = null;
    }
        return result;
    },

  _utfDecode: function (c) {
    if (c >= 93) {
      c--;
    }
    if (c >= 35) {
      c--;
    }
    return c - 32;
  },

    _utfEncode: function (c) {
        //reverse of above, returns charCode for c
        //derived from: https://github.com/mapbox/glower/blob/mb-pages/src/glower.js#L37
        var charCode = c + 32;
        if (charCode >= 34) {
            charCode ++;
        }
        if (charCode >= 92) {
            charCode ++;
        }
        return charCode;
    }
});

L.utfGrid = function (url, options) {
  return new L.UTFGrid(url, options);
};


L.UTFGridCanvas = L.UTFGrid.extend({
	options: {
        idField: 'ID',  // Expects UTFgrid to have a property 'ID' that indicates the feature ID
        buildIndex: true,  // requires above field to be set properly
        fillColor: 'black',
	    shadowBlur: 0,  // Number of pixels for blur effect
        shadowColor: null,  // Color for shadow, if present.  Defaults to fillColor.
        debug: true  // if true, show tile borders and tile keys
    },

    _adjacentTiles: null,

    onAdd: function (map) {
        this._adjacentTiles = [];

        L.UTFGrid.prototype.onAdd.call(this, map);
	},

    createTile: function(coords) {
        this._loadTile(coords);

        var tile = document.createElement('canvas');
        tile.width = tile.height = this.options.tileSize;

        if (this.options.debug) {
            this._drawDefaultTile(tile.getContext('2d'), this._tileCoordsToKey(coords));
        }

        return tile;
	},

    _connectMapEventHandlers: function(){
        L.UTFGrid.prototype._connectMapEventHandlers.call(this);
        this.on('mouseover', this._handleMouseOver, this);
        this.on('mouseout', this._handleMouseOut, this);
    },

    _disconnectMapEventHandlers: function(){
        L.UTFGrid.prototype._disconnectMapEventHandlers.call(this);
        this.off('mouseover', this._handleMouseOver, this);
        this.off('mouseout', this._handleMouseOut, this);
    },

    _handleMouseOver: function (e) {
        if (e._tile == null || e._tileCharCode == null){ return }

        this._clearAdjacentTiles();

        // currently over this tile:
        var curTile = e._tile;
        this._drawTile(curTile, parseInt(e._tileCharCode.split(':')[3]));

        if (e.data && this._idIndex) {
            // draw adjacent tiles
            var id = e.data[this.options.idField];
            var zoomLevel = curTile.split(':')[2];
            if (!(id && this._idIndex[id] && this._idIndex[id][zoomLevel])) { return }

            var idx = this._idIndex[id][zoomLevel];
            for (var tileKey in idx) {
                //TODO: screen out any tiles that are not currently visible?
                if (tileKey !== curTile) {
                    this._drawTile(tileKey, idx[tileKey]);
                    this._adjacentTiles.push(tileKey);
                }
            }
        }
    },

    _handleMouseOut: function (e) {
        this._resetTile(e._tile);
        this._clearAdjacentTiles();
    },

    _clearAdjacentTiles: function() {
        // clear out any adjacent tiles that were drawn
        if (this._adjacentTiles) {
            for (var i = 0; i < this._adjacentTiles.length; i++) {
                this._resetTile(this._adjacentTiles[i]);
            }
            this._adjacentTiles = [];
        }
    },

    _handleTileLoad: function(tileKey, data) {
        // build index: {<id: {zoomLevel: {tileKey: tileCharCode} } }
        if (this.options.buildIndex) {
            var id, props, idx;
            var idField = this.options.idField;
            var zoomLevel = tileKey.split(':')[2];
            for (var i = 0; i < data.keys.length; i++) {
                props = data.data[data.keys[i]];
                if (props) {
                    id = props[idField];
                    if (id) {
                        if (this._idIndex[id] == null) {
                            this._idIndex[id] = {};
                        }
                        idx = this._idIndex[id];
                        if (idx[zoomLevel] == null) {
                            idx[zoomLevel] = {};
                        }utfGrid
                        idx[zoomLevel][tileKey] = this._utfEncode(i);
                    }
                }
            }
        }
    },

    _drawTile: function(tileKey, charCode) {
        // for a given tile, find all pixels that match character and repaint
        // TODO: request animation frame?

        if (this._tiles[tileKey] == null){ return }

        var canvas = this._tiles[tileKey].el;
        var ctx = canvas.getContext('2d');

        this._resetTile(tileKey);
        var grid = this._cache[tileKey].grid;

        ctx.fillStyle = this.options.fillColor;
        var dim = this.options.tileSize / this.options.resolution;

        // TODO: order of traversal here may be backwards?  Do y then x?  (are data column major or row major?)
        //modified slightly from: https://github.com/mapbox/glower/blob/mb-pages/src/glower.js
        for (var x = 0; x < dim; x++) {
            for (var y = 0; y < dim; y++) {
                if (grid[y].charCodeAt(x) === charCode) {
                    var sweep = 1;
                    while (y < 63 && grid[y + 1].charCodeAt(x) === charCode) {
                        y++;
                        sweep++;
                    }
                    ctx.fillRect(x * 4, (y * 4) - ((sweep - 1) * 4), 4, 4 * sweep);
                }
            }
        }

        if (this.options.shadowBlur) {
            this._addShadow(canvas, ctx);
        }
	
    },

    _resetTile: function(tileKey) {
        // clear the canvas
        if (this._tiles[tileKey] == null){ return }

        var tile = this._tiles[tileKey].el;
        tile.width = this.options.tileSize;  // hard reset of canvas

        if (this.options.debug) {
            this._drawDefaultTile(tile.getContext('2d'), tileKey);
        }
    },

    _drawDefaultTile: function(ctx, tileKey) {
        // if this.options.debug, add tileKey text and borders
        ctx.fillStyle = 'black';
        ctx.fillText(tileKey, 20, 20);
        ctx.strokeStyle = 'red';
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(255, 0);
        ctx.lineTo(255, 255);
        ctx.lineTo(0, 255);
        ctx.closePath();
        ctx.stroke();
    },

    _addShadow: function(canvas, ctx) {
        ctx.shadowBlur = this.options.shadowBlur;
        ctx.shadowColor = this.options.shadowColor || this.options.fillColor;

        //Blur effect copied from glower - https://github.com/cutting-room-floor/glower/blob/mb-pages/src/glower.js#L108
        ctx.globalAlpha = 0.7;
        ctx.globalCompositeOperation = 'lighter';
        var a = 1;
        ctx.drawImage(canvas, -a, -a);
        ctx.drawImage(canvas, a, a);
        ctx.drawImage(canvas, 0, -a);
        ctx.drawImage(canvas, -a, 0);
        ctx.globalAlpha = 1;
    }
});


L.utfGridCanvas = function (url, options) {
	return new L.UTFGridCanvas(url, options);
};

export default class UtfGrid extends GridLayer {
  static propTypes = {
    children: PropTypes.childrenType,
    opacity: PropTypes.number,
    url: PropTypes.string.isRequired,
    zIndex: PropTypes.number,
    callbacks: PropTypes.array,
    epsg: PropTypes.string,
    layer: PropTypes.string,
  }

  createLeafletElement (props: Object): Object {
    const { url, callbacks, epsg, layer, limits, ...options } = props;
    
    var url_with_param = url + '/gwc/service/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER='+layer+'&STYLE=&TILEMATRIXSET='+epsg+'&TILEMATRIX='+epsg+'%3A{z}&TILEROW={y}&TILECOL={x}&FORMAT=application%2Fjson%3Btype%3Dutfgrid';
    var utfGrid = new L.utfGrid(url_with_param, {
        useJsonP: false,
        epsg: epsg,
        layer: layer,
        limits: limits
    });

    callbacks.forEach(function(v, i) {
        utfGrid.on(v.event, v.f);
    })
    
    return utfGrid;
  }

  updateLeafletElement (fromProps: Object, toProps: Object) {
    const { url, callbacks, epsg, layer, limits, ...options } = fromProps;
    
    var url_with_param = url + '/gwc/service/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER='+layer+'&STYLE=&TILEMATRIXSET='+epsg+'&TILEMATRIX='+epsg+'%3A{z}&TILEROW={y}&TILECOL={x}&FORMAT=application%2Fjson%3Btype%3Dutfgrid';
    var utfGrid = new L.utfGrid(url_with_param, {
        useJsonP: false,
        epsg: epsg,
        layer: layer,
        limits: limits
    });

    callbacks.forEach(function(v, i) {
        utfGrid.on(v.event, v.f);
    });
    this.leafletElement = utfGrid;
    // if (!isEqual(params, prevParams)) {
    //   this.leafletElement.setParams(params)
    // }
  }
}



// WEBPACK FOOTER //
// src/components/MapControl/UtfGrid.js